import React, {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import Validation from '../../components/Validation';
import Phone from '../../components/Phone';
import {MUTATION_CLIENT_SAVE} from './graphql';
import Select from 'react-select/base';
import {QUERY_CITY_LIST} from '../City/graphql';

const Register = ({login, loginLoading, loginError}) => {
  const [fullname, setFullname] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [cityId, setCityId] = useState(0);

  const [save, {loading, called, data}] = useMutation(MUTATION_CLIENT_SAVE, {
    onCompleted: data1 => {
      if (data1 && data1.clientSave.obj) {
        login({username, password});
      }
    },
  });

  const {cityList} = useQuery(QUERY_CITY_LIST).data || {cityList: []};

  return (
    <div>
      <div className="mt-4 mb-3 text-left">
        <label className="mb-1">Ваш город</label>
        <select
          value={cityId}
          onChange={e => setCityId(e.target.value)}
          className="form-control form-control-lg font-4"
        >
          <option value="0">Выберите из списка</option>
          {cityList.map(op => (
            <option key={op.id} value={op.id}>
              {op.name}
            </option>
          ))}
        </select>
        <Validation data={data} field="city" />
      </div>
      <div className="mb-3 text-left">
        <label className="mb-1">Ваше имя</label>
        <input
          value={fullname}
          onChange={e => setFullname(e.target.value)}
          type="text"
          className="form-control form-control-lg font-4"
        />
        <Validation data={data} field="fullname" />
      </div>
      <div className="mb-3 text-left">
        <label className="mb-2">Телефон</label>
        <Phone onChange={value => setPhone(value)} />
        <Validation data={data} field="phone" />
      </div>
      <div className="mb-3 text-left">
        <div className="mb-1">Email</div>
        <input
          value={username}
          onChange={e => setUsername(e.target.value)}
          type="text"
          className="form-control form-control-lg font-4"
          placeholder="Для авторизаций"
        />
        {data && data.clientSave && data.clientSave.errors && data.clientSave.errors[0].field === 'username' && (
          <div className="text-success font-4 mt-2">
            Вы зарегистрировались, нажмите <span className="text-warning">Логин</span> и введите ваши данные
          </div>
        )}
        {/* <Validation
          data={data}
          field="username"
          ref={node => {
            if (node) {
              node.style.setProperty('color', 'green', 'important');
            }
          }}
        /> */}
      </div>
      <div className="mb-4 text-left">
        <div className="mb-1">Пароль</div>
        <input
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
          className="form-control form-control-lg font-4"
          placeholder="Для авторизаций"
        />
        <Validation data={data} field="password" />
      </div>
      <button
        onClick={() =>
          save({variables: {input: {username: username.toLowerCase(), password, phone, fullname, city: cityId, partnerRef: localStorage.getItem('ref@quiz-client') || ''}}})
        }
        className="btn btn-primary btn-lg font-4 d-block my-4 w-100"
      >
        {loading || loginLoading ? `Отправка...` : `Регистрация`}
      </button>
    </div>
  );
};

export default Register;
